import { render, staticRenderFns } from "./DiagramNew.vue?vue&type=template&id=61cfb86e&scoped=true&"
import script from "./DiagramNew.vue?vue&type=script&lang=js&"
export * from "./DiagramNew.vue?vue&type=script&lang=js&"
import style0 from "./DiagramNew.vue?vue&type=style&index=0&id=61cfb86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cfb86e",
  null
  
)

export default component.exports